import React, { useState, useRef } from 'react';
import LeftSidebar from '../../Tools/LeftSidebar';
import Topbar from '../../Tools/Topbar';
import Settings from '../../Tools/Setting/Settings';
import useSettings from '../../Tools/Setting/useSettings';
import api from '../../../../api'; // Import the API module

const Profile = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const { settings, updateSetting, handleColorTheme } = useSettings();
  const settingsRef = useRef();

  // Spinner loading state
  const [loading, setLoading] = useState(false);

  // State for form fields
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    message: ''
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start spinner
    try {
      await api.post('/ems/contact/send', formData);
      alert('Message sent successfully!');
      // Reset form after successful submission
      setFormData({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Failed to send message. Please try again.');
    } finally {
      setLoading(false); // Stop spinner
    }
  };

  return (
    <div id="main-wrapper">
      <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
        <Topbar toggleSidebar={toggleSidebar} />
        <div className="body-wrapper">
          <div className="container-fluid">
            <Settings
              ref={settingsRef}
              updateSetting={updateSetting}
              handleColorTheme={handleColorTheme}
              settings={settings}
            />
          
          <div className="card w-100 position-relative overflow-hidden">
            <div className="px-4 py-3">
              <h5 className="card-title fw-semibold mb-0 lh-sm">Contact Us</h5>
              <p className="card-subtitle mb-0 mt-1">We’re here to help. Reach out to us anytime with your questions or feedback.</p>
            </div>
            <div className="card-body p-4">
              <div className="py-3 px-0">
                <div className="profile-first-panel">
                  <div className="col-lg-8">
                    <div className="row mb-3">
                      <div className="col-sm-4">
                        <h6 className="fw-semibold mb-0">Email:</h6>
                      </div>
                      <div className="col-sm-8">
                        <p className="mb-0">support@wavetechsa.com</p>
                      </div>
                    </div>  
                    <div className="row mb-3">
                      <div className="col-sm-4">
                        <h6 className="fw-semibold mb-0">Phone: </h6>
                      </div>
                      <div className="col-sm-8">
                        <p className="mb-0">+966 5 0000 0000 (Saudi Arabia)</p>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-sm-4">
                        <h6 className="fw-semibold mb-0">Support Hours:</h6>
                      </div>
                      <div className="col-sm-8">
                        <p className="mb-0">24/7.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="my-5"/>

                <div className="profile-edit-form">
                  <h5 className="card-title fw-semibold mb-4 lh-sm">Contact Form</h5>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>First Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                   
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Email Address</label>
                        <input
                          type="text"
                          className="form-control"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                   
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Phone Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>  
                    
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label>Message</label>
                        <textarea
                          className="form-control"
                          rows="5"
                          name="message"
                          value={formData.message}
                          onChange={handleInputChange}
                        ></textarea>
                      </div>
                    </div>
                    
                    <div className="col-md-6">
                      <button
                        type="submit"
                        className="btn waves-effect waves-light btn-outline-primary d-flex align-items-center"
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                            Sending...
                          </>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default Profile;
